import { ILevelPrerequisite } from "./../../../../../interfaces/level-prequisite";
import { LevelPrerequisiteEntryComponent } from "./../level-prerequisite-entry/level-prerequisite-entry.component";
import { MatDialog } from "@angular/material";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { ActivatedRoute } from "@angular/router";
import { LevelInfoPrerequisiteService } from "src/app/services/http/business/levelInfo-prerequisite/level-info-prerequisite.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";

@Component({
  selector: "app-level-prerequisite-list",
  templateUrl: "./level-prerequisite-list.component.html",
  styleUrls: ["./level-prerequisite-list.component.css"]
})
export class LevelPrerequisiteListComponent implements OnInit {
  packageData: any = {
    PackageId: 0,
    bid: 0
  };
  levelPrequisiteData: any = [];
  levelData: any = [];

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private levelInfoService: LevelInfoService,
    private prerequisiteService: LevelInfoPrerequisiteService
  ) {}

  ngOnInit() {
    this.refresh();
  }
getList(){
  this.prerequisiteService.getList(this.packageData.packageId).subscribe(() => {
    this.refresh();
});
}
  refresh() {
    this.route.params.subscribe(res => {
      this.packageData = res;
      this.levelInfoService.getById(res.bid).subscribe(levelInfo => {
        this.levelData = levelInfo;
      });
      this.prerequisiteService.getLevelInfo(res.bid).subscribe(re => {
       
        this.levelPrequisiteData = re ? re : [];  
      });
    });
  }

  add() {
    this.dialog
      .open(LevelPrerequisiteEntryComponent, {
        data: this.packageData
      })
      .afterClosed()
      .subscribe(() => {
        // this.prerequisiteService
        //   .getList(this.packageData.packageId)
        //   .subscribe(() => {
        //     this.refresh();
        //   });
        this.getList();
      });
  }

  edit(e: any) {
    e.bid = this.packageData.bid;
    e.packageId = parseInt(this.packageData.packageId);
    this.dialog
      .open(LevelPrerequisiteEntryComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(() => {
        // this.prerequisiteService
        //   .getList(this.packageData.packageId)
        //   .subscribe(() => {
        //     this.refresh();
        //   });
        this.getList();
      });
  }

  delete(data: ILevelPrerequisite): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.level") + " " + data.LevelName
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let params = {
          id: data.Id
        };
        this.prerequisiteService.delete(params).subscribe(() => {
          this.getList();  
        },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }
}
